import ServiceGuideDetailsItem from "../Components/ServiceGuideDetailsItem";

const ServiceGuideDetails = () => {
return( <ServiceGuideDetailsItem />)
}
export default ServiceGuideDetails;